import React from "react";
import { loadTrustpilot } from "./trust-box-helper";

// See: https://support.trustpilot.com/hc/en-us/articles/115011421468--Add-a-TrustBox-widget-to-a-single-page-application#add-a-trustbox-widget-with-a-react-application-1

export interface TrustBoxProps {
  locale: string;
  templateId: string;
  businessunitId: string;
  height: string;
  width: string;
  theme: string;
  reviewUrl?: string;
  stars?: string;
}

const TrustBox = ({ locale, templateId, businessunitId, height, reviewUrl, theme, stars, width }: TrustBoxProps) => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);

  React.useEffect(() => {
    loadTrustpilot(ref.current);
  }, []);

  return (
    <div
      ref={ref} // We need a reference to this element to load the TrustBox in the effect.
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id={templateId}
      data-businessunit-id={businessunitId}
      data-style-height={height}
      data-style-width={width}
      data-theme={theme}
      data-stars={stars}
    >
      {reviewUrl && (
        <a href={reviewUrl} target="_blank" rel="noopener">
          Trustpilot
        </a>
      )}
    </div>
  );
};
export default TrustBox;
